"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _idbReactIconlib = require("@identitybuilding/idb-react-iconlib");

var _idbReactIconlib2 = _interopRequireDefault(_idbReactIconlib);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var readMore = document.getElementsByClassName("read-more");
var readLess = document.getElementsByClassName("read-less");
var extraText = document.getElementsByClassName("extra-text");

var ReviewItem = function ReviewItem(props) {
  var allStars = [];

  var addStars = function addStars(stars) {
    for (var i = 0; i < stars; i++) {
      allStars.push(_react2.default.createElement(_idbReactIconlib2.default, { key: i, name: "StarFill" }));
    }
    if (allStars !== 5) {
      for (var _i = allStars.length; _i < 5; _i++) {
        allStars.push(_react2.default.createElement(_idbReactIconlib2.default, { key: _i, name: "Star" }));
      }
    }
  };

  var toggleText = function toggleText() {
    console.log(readMore[props.review.id]);
    console.log("hiiiiiiiii");
    if (readMore[props.review.id].style.display === "none") {
      readMore[props.review.id].style.display = "inline";
      readLess[props.review.id].style.display = "none";
      extraText[props.review.id].style.display = "none";
    } else {
      readMore[props.review.id].style.display = "none";
      readLess[props.review.id].style.display = "contents";
      extraText[props.review.id].style.display = "contents";
    }
  };

  return _react2.default.createElement(
    "div",
    { className: "card" },
    _react2.default.createElement(
      "div",
      { id: "box1" },
      _react2.default.createElement(
        "div",
        { id: "profile" },
        _react2.default.createElement("img", { src: props.review.image })
      ),
      _react2.default.createElement(
        "div",
        { className: "profile-content" },
        _react2.default.createElement(
          "h3",
          null,
          props.review.prename,
          " ",
          props.review.name
        ),
        _react2.default.createElement(
          "span",
          null,
          "(",
          props.review.date,
          ")"
        )
      )
    ),
    _react2.default.createElement(
      "div",
      { id: "box2" },
      _react2.default.createElement(
        "p",
        null,
        props.review.text.slice(0, 100),
        _react2.default.createElement(
          "a",
          { className: "read-more", onClick: toggleText },
          " ",
          "read more"
        ),
        _react2.default.createElement(
          "p",
          { className: "extra-text" },
          props.review.text.slice(100, 5000)
        ),
        " "
      ),
      " ",
      _react2.default.createElement(
        "a",
        { className: "read-less", onClick: toggleText },
        "show less"
      ),
      _react2.default.createElement(
        "figure",
        { id: "stars" },
        addStars(props.review.stars),
        allStars
      )
    )
  );
};

exports.default = ReviewItem;